export const xeroMatchingV2HelpItemId = 'matching-v2-popup-help';
export const qbooksMatchingHelpItemId = 'qbooks-matching-popup-help';
export const multilinePlaceholders = ['TERMS'];
export const starterGuideActionsClass = 'starter-guide-actions';
